import * as yup from 'yup'

import { UserRole } from '../../utils/constants'
import { validatePhoneNumber } from '../../utils/helper-functions'
import {
    ALL_LANGUAGE_CHARACTER_STRING,
    HYDRAFACIAL_EMAIL,
} from '../../utils/regex'

export const onboardingStep1Schema = () =>
    yup.object().shape({
        firstName: yup
            .string()
            .matches(
                ALL_LANGUAGE_CHARACTER_STRING,
                'onboarding_name_page.onboarding_valid_firstname_error'
            )
            .required('onboarding_name_page.onboarding_firstname_error')
            .max(50, 'onboarding_name_page.onboarding_first_name_length_error'),
        lastName: yup
            .string()
            .matches(
                ALL_LANGUAGE_CHARACTER_STRING,
                'onboarding_name_page.onboarding_valid_lastname_error'
            )
            .required('onboarding_name_page.onboarding_lastname_error')
            .max(50, 'onboarding_name_page.onboarding_last_name_length_error'),
        mobilePhoneNumber: yup
            .string()
            .trim()
            .test(
                'is-phone-number-valid',
                'authentication_flow_common_elements.phone_valid_error',
                function (value) {
                    const { valid, error } = validatePhoneNumber(
                        value as string
                    )
                    return valid || this.createError({ message: error })
                }
            )
            .required('authentication_flow_common_elements.enter_phone_error'),
        emailAddress: yup
            .string()
            .email('onboarding_email_page.onboarding_valid_email_error')
            .test(
                'hydrafacial-email',
                'sign_in_page.employee_error',
                (value) => !value || !HYDRAFACIAL_EMAIL.test(value)
            )
            .required('onboarding_email_page.onboarding_email_error'),
        acceptTerms: yup
            .boolean()
            .oneOf(
                [true],
                'onboarding_phone_page.onboarding_phone_policy_error'
            ),
        optInDataSharingAgreement: yup
            .boolean()
            .when(['userRole', 'countrySelected'], {
                is: (userRole: string, countrySelected: string) =>
                    userRole !== UserRole.Client &&
                    (countrySelected === 'ca' || countrySelected === 'us'),
                then: yup
                    .boolean()
                    .oneOf(
                        [true],
                        'onboarding_phone_page.onboarding_datasharing_agreement_error'
                    ),
            }),
    })
